export const home_lables = {
    "corvus": "Ask queries on your sample corvus dataset.",
    "easyeat": "Ask queries on your sample easyeat dataset.",
    "frikedia": "Ask queries on your sample frikedia dataset.",
    "ecommerce": "Ask your queries on our sample ecommerce database."
}